import React from 'react';
import { FormApiInterface } from 'react-uforms';

import { Question } from '@ch/common/types/data';
import { NotificationProps as Notification } from '@ch/common/components/notification/types';
import { QuestionDocuments } from './types';

export const QuizContext = React.createContext<{
  pregnancyValues: {};
  setPregnancyValues: (value: any) => any;
  documents: QuestionDocuments[];
  setDocuments: (documents: QuestionDocuments[]) => void;
  validation: { [key: string]: any };
  setValidation: (value: any) => any;
  userQuestions: Question[];
  setQuestion: (questions: Question) => void;
  resetUserQuestions: (api: FormApiInterface) => void;
  submitted: boolean;
  setSubmitted: (value: boolean) => void;
  addNotification: (notification: Notification) => void;
  intakeId: string;
  token?: string;
  recaptchaSiteKey?: string;
  refreshToken: (token?: string) => Promise<void>;
  pregnancyFile: File;
  setPregnancyFile: (value: any) => any;
}>(null);
